import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgAlertWarning: React.FunctionComponent<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 102 102" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#404040" cx={51} cy={51} r={51} />
      <path fill="#FFF" d="M45.24 29h10.57L55 60h-8.53z" />
      <ellipse fill="#FFF" cx={50.5} cy={69} rx={5.5} ry={5} />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgAlertWarning;
